<template>
  <nav id="categories" class="categories">
    <ul class="categories__list" :class="`categories__list--${numCategories}`">
      <li v-for="category in categories" :key="category.CONSTANT" class="categories__list-item">
        <router-link :to="`category/${category.SLUG}`" class="categories__link" :class="`categories__link--${category.COLOR}`"
          ><h2 class="categories__link-heading">{{ category.DISPLAY_NAME }}</h2></router-link
        >
      </li>
    </ul>
  </nav>
</template>

<script>
// import {createNamespacedHelpers} from 'vuex';
import firebase from 'firebase/app';
import db from '../firebaseInit';
import {CATEGORIES} from './../constants/globalConstants';

// const userVuexModule = createNamespacedHelpers('userVuexModule');

export default {
  name: 'Categories',
  title: 'Categories',
  data() {
    return {};
  },
  created() {},
  methods: {},
  computed: {
    // ...userVuexModule.mapGetters(['']),
    categories: function() {
      return CATEGORIES;
    },
    numCategories: function() {
      return Object.keys(this.categories).length;
    },
  },
};
</script>

<style lang="scss" scoped>
.categories {
  bottom: 1rem;
  left: 1rem;
  position: absolute;
  right: 1rem;
  top: 7.5rem;

  &__list {
    column-gap: 1rem;
    display: grid;
    grid-auto-rows: 1fr;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    height: 100%;
    list-style: none;
    margin: 0;
    padding: 0;
    row-gap: 1rem;

    @include breakpoint($mq-md) {
      column-gap: 2rem;
      row-gap: 2rem;
    }

    &--5,
    &--6 {
      grid-template-rows: repeat(3, minmax(0, 1fr));
    }

    &--7,
    &--8 {
      grid-template-rows: repeat(4, minmax(0, 1fr));
    }

    &--9,
    &--10 {
      grid-template-rows: repeat(5, minmax(0, 1fr));
    }

    &--11,
    &--12 {
      grid-template-rows: repeat(6, minmax(0, 1fr));
    }
  }

  &__list-item {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  &__link {
    background-color: grey;
    border-radius: var(--border-radius);
    display: block;
    height: 100%;
    padding: 1rem 1rem 1rem 1rem;
    text-decoration: none;

    @include breakpoint($mq-sm) {
      padding: 2rem 1rem 1rem 1rem;
    }

    @include breakpoint($mq-sm-md) {
      padding: 2rem 1rem 1rem 2rem;
    }

    @include breakpoint($mq-md) {
      padding: 2.5rem 1rem 1rem 2.5rem;
    }

    @include breakpoint($mq-md-lg) {
      padding: 3rem 1rem 1rem 3rem;
    }

    &--yellow {
      background-color: var(--color-yellow);

      &:hover {
        background-color: var(--color-yellow-darkish);
      }

      .categories__link-heading {
        color: var(--color-white);
      }
    }

    &--orange {
      background-color: var(--color-orange);

      &:hover {
        background-color: var(--color-orange-darkish);
      }

      .categories__link-heading {
        color: var(--color-orange-foreground);
      }
    }

    &--pink {
      background-color: var(--color-pink);

      &:hover {
        background-color: var(--color-pink-darkish);
      }

      .categories__link-heading {
        color: var(--color-pink-foreground);
      }
    }

    &--violet {
      background-color: var(--color-violet);

      &:hover {
        background-color: var(--color-violet-darkish);
      }

      .categories__link-heading {
        color: var(--color-violet-foreground);
      }
    }

    &--blue {
      background-color: var(--color-blue);

      &:hover {
        background-color: var(--color-blue-darkish);
      }

      .categories__link-heading {
        color: var(--color-blue-foreground);
      }
    }

    &--green {
      background-color: var(--color-green);

      &:hover {
        background-color: var(--color-green-darkish);
      }

      .categories__link-heading {
        color: var(--color-green-foreground);
      }
    }

    &--teal {
      background-color: var(--color-teal);

      &:hover {
        background-color: var(--color-teal-darkish);
      }

      .categories__link-heading {
        color: var(--color-teal-foreground);
      }
    }

    &--brown {
      background-color: var(--color-brown);

      &:hover {
        background-color: var(--color-brown-darkish);
      }

      .categories__link-heading {
        color: var(--color-brown-foreground);
      }
    }
  }

  &__link-heading {
    font-size: 1.6rem;
    line-height: 1;
    margin: 0;
    text-shadow: 0px 0px 5px #000;

    @include breakpoint($mq-sm) {
      font-size: 2rem;
    }

    @include breakpoint($mq-sm-md) {
      font-size: 2.6rem;
    }

    @include breakpoint($mq-md) {
      font-size: 3rem;
    }

    @include breakpoint($mq-lg-xlg) {
      font-size: 3.5rem;
    }

    @include breakpoint($mq-xlg) {
      font-size: 4rem;
    }
  }
}
</style>
